"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSymmetryRanks = void 0;
const getXAtomicNumber_js_1 = require("./getXAtomicNumber.js");
/**
 * Returns an array of symmetry ranks.
 * @param {import('openchemlib').Molecule} molecule An instance of a molecule
 * @returns
 */
function getSymmetryRanks(molecule) {
    const { Molecule } = molecule.getOCL();
    const xAtomNumber = (0, getXAtomicNumber_js_1.getXAtomicNumber)(molecule);
    // most of the molecules have some symetry
    const internalMolecule = molecule.getCompactCopy();
    for (let i = 0; i < internalMolecule.getAllAtoms(); i++) {
        // hydrogens are not taken into account during canonization, we need to change them with an atom with a valence of 1
        if (internalMolecule.getAtomicNo(i) === 1) {
            internalMolecule.setAtomicNo(i, xAtomNumber);
        }
    }
    internalMolecule.ensureHelperArrays(Molecule.cHelperSymmetryStereoHeterotopicity);
    const symmetryRanks = [];
    for (let i = 0; i < molecule.getAllAtoms(); i++) {
        symmetryRanks.push(internalMolecule.getSymmetryRank(i));
    }
    return symmetryRanks;
}
exports.getSymmetryRanks = getSymmetryRanks;
//# sourceMappingURL=getSymmetryRanks.js.map